/* One way to email a quote: fill the composer and let the person read it before
   it goes. Every send button routes through here, so the wording a customer
   receives is the same wherever it was started from. */
export const quoteEmailPrefill = (q, fallback = {}) => {
  const linkType = q?.link_type || fallback.linkType;
  const linkId = q?.link_id || fallback.linkId;
  if (!linkType || !linkId) return null;

  const link = q.public_token ? `${window.location.origin}/quote/${q.public_token}` : "";
  const body =
    "<p>Hi {{first_name}},</p>" +
    `<p>Thanks for your time. Please find your EQUIPR quote <strong>${q.quote_number}</strong> ready to review below.</p>` +
    (link ? `<p><a href="${link}">View &amp; accept your quote (${q.quote_number})</a></p>` : "") +
    "<p>You can review and accept it online, and I'm happy to walk you through anything — just reply to this email.</p>";

  return {
    dest: linkType === "client" ? `/clients/${linkId}/email` : `/prospects/${linkId}/email`,
    state: { emailPrefill: {
      subject: `Your EQUIPR quote ${q.quote_number}`,
      body_html: body,
      to_email: q.contact_email || "",
      quote_id: q.id,
      quote_number: q.quote_number,
    } },
  };
};
